import {
  CountryCode,
  formatIncompletePhoneNumber,
  parsePhoneNumber,
} from 'libphonenumber-js/max'

export function getPhoneWithoutCallingCode(phone?: string) {
  if (!phone) return ''

  const parsedPhoneNumber = parsePhoneNumber(phone)
  if (!parsedPhoneNumber) return phone

  return formatIncompletePhoneNumber(
    parsedPhoneNumber.nationalNumber,
    parsedPhoneNumber.country,
  )
}

export function getPhoneCountry(phone?: string) {
  if (!phone) return null

  const parsedPhoneNumber = parsePhoneNumber(phone)
  if (!parsedPhoneNumber) return null

  return parsedPhoneNumber.country
}

export function formatPhone(phone: string, country: string) {
  if (!phone) return ''

  const parsedPhoneNumber = parsePhoneNumber(phone, country as CountryCode)

  if (!parsedPhoneNumber) return phone

  return parsedPhoneNumber.formatInternational()
}
